import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged
} from 'firebase/auth';
import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from './firebase';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState({
    loading: true,
    user: null,
    userData: null,
  });

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        try {
          const snap = await getDoc(doc(db, 'users', firebaseUser.uid));
          setState({
            loading: false,
            user: firebaseUser,
            userData: snap.exists() ? snap.data() : null,
          });
        } catch {
          setState({ loading: false, user: firebaseUser, userData: null });
        }
      } else {
        setState({ loading: false, user: null, userData: null });
      }
    });
    return unsub;
  }, []);

  async function register({ email, password, name, phone, zone }) {
    const cred = await createUserWithEmailAndPassword(auth, email, password);
    await setDoc(doc(db, 'users', cred.user.uid), {
      uid: cred.user.uid,
      email, name,
      phone: phone || '',
      zone: zone || '',
      role: 'embajadora',
      approved: false,
      createdAt: serverTimestamp()
    });
  }

  async function login(email, password) {
    await signInWithEmailAndPassword(auth, email, password);
  }

  async function logout() {
    await signOut(auth);
    // Recarga la página — solución definitiva, limpia todo el estado
    window.location.href = '/admin';
  }

  return (
    <AuthContext.Provider value={{
      user: state.user,
      userData: state.userData,
      loading: state.loading,
      register,
      login,
      logout,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}